import React from "react"

import CollapsableExpHead from "../components/CollapsableExpHead"
import SkillTag from "../components/SkillLogoTag"
import Project from "../components/Project"
import DropDown from "../components/DropDown"
import CollapsableCard from "../components/CollapsableCard"

type Project = {
  name: string
  points: string[]
}

type RelatedSkill = {
  name: string
  icon: string
  proficiency: string
}

type Job = {
  projectrole: string
  teamname: string
  totaltime: string
  startandend: string
  companylogo: string
  companyname: string
  description: string
  projects: Project[]
  relatedskills?: RelatedSkill[]
}

type Props = {
  jobs: Job[]
}

const ExpViewBuilder = ({jobs}: Props) => {
  return (
    <>
    {jobs.map((job, index) => {
      const Head = () =>
        <CollapsableExpHead
          projectrole={job.projectrole}
          teamname={job.teamname}
          totaltime={job.totaltime}
          startandend={job.startandend}
          companylogo={job.companylogo}
          companyname={job.companyname}
        />
      
      const Related = () =>
        <>
        {job.relatedskills && job.relatedskills.map(skill => (
          <SkillTag
            name={skill.name}
            icon={skill.icon}
            proficiency={skill.proficiency}
            standalone
            key={skill.name}
          />
        ))}
        </>
      
      const Projects = () =>
        <>
        {job.projects.map(project => (
          <Project
            name={project.name}
            points={project.points}
            key={project.name}
          />
        ))}
        </>
      
      const Drop = () =>
        <DropDown
          description={job.description}
          customtext={<Projects/>}
          relatedtech={job.relatedskills && <Related/>}
          isjob
        />

      return (
        <CollapsableCard
          head={<Head/>}
          dropdown={<Drop/>}
          key={index}
        />
      )
    })}
    </>
  )
}

export default ExpViewBuilder